import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { renderComponent, renderNothing, branch, compose } from 'recompose'
import FontIcon from 'react-toolbox/lib/font_icon'

import styles from './styles.scss'

const withStyles = CSSModules(styles)
const SortDownIcon = withStyles(() => <FontIcon styleName='headerSortIcon' value='arrow_drop_down'/>)
const SortUpIcon = withStyles(() => <FontIcon styleName='headerSortIcon' value='arrow_drop_up'/>)

const SortIcon = compose(
  branch(
    ({ currentIndex, columnIndex }) => currentIndex !== columnIndex,
    renderNothing
  ),
  branch(
    ({ sortBy }) => sortBy === 'desc',
    renderComponent(SortDownIcon),
  )
)(SortUpIcon)

export default SortIcon